var anniversary = new Vue({
    el:'#anniversary',
    data(){ 
        return {
            // 加载完成
            loadFlag:false,
            // 发送验证码标识
            sendFlag:false,
            loginFlag:false,
            addressFlag:false,
            formFlag:false,
            downloadFlag:false,
            uploadFlag:false,
            popup:false,
            loginPopup:false,
            formPopup:false,
            prizePopup:false,
            addressPopup:false,
            recordPopup:false,
            isSend:false,
            isLogin:false,
            sendText:'Send code',
            user:{
                name:'',
                email:'',
                code:'',
                country:'Country',
                chance:0
            },
            submitFlag:true,
            popup1:false,
            select_flag1:0,
            countryArr:[],
            arr1:['Innovative','Professional','Stylish'],
            arr2:['Long Battery Life','Great Flavor','Unique Design'],
            arr3:['More Innovative Devices','Better Flavor','New Stylish Designs'],
            text1:'',
            text2:'',
            text3:'',
            randomTimes:[],
            // 可抽奖标识
            isLottery:true,
            prizeAll:{
                Apple_Watch_Series_10:false,
                Anniversary_Gift_Box:false,
                OXVA_XLIM_Pro_2:false,
                Anniversary_Gift_Pack:false,
                Lucky_Try:false,
            },
            className:'',
            prizeName:'',
            address:{
                state:'',
                city:'',
                street:'',
                postal:'',
                phone:''
            },
            winners:[],
            blessing:[],
            myBlessing:'',
            // 控制图片显示
            imgFlag:false,
            imgFlag2:false,
            imgArr:[
                'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/1_ab7a2bdd-ca91-41e1-ad66-f53260f04bb2.jpg',
                'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/2_2fea3818-b3c3-44bc-be19-2b839587f1f2.jpg',
                'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/3_3e02e725-d071-4761-a54e-e6bd7e7672c6.jpg',
                'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/20241031-155413.jpg',
                'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/5_0b8b0171-0e45-43ec-a1b8-943faa181e5b.jpg'
            ],
            imgIndex:'0',
            file:[],
            uploadImg:'',
            imgStyle:false,
            findText:'',
            chancePopup:false,
            emailStr:''
        }
    },
    methods: {
        async addShareChance(){
            var emailArr = this.emailStr.split('\n')
            var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,flag=true
            for(let i=0;i<emailArr.length;i++){
                if(!emailReg.test(emailArr[i])){
                    flag=false
                }
            }
            if(flag){
                showMessage('Submitted successfully','success')
                var resultString = emailArr.map(email => `'${email}'`).join(',');
                var params=new URLSearchParams();
                params.append('info',JSON.stringify({token:this.user.token,str:resultString}));
                let res = await axios.post('https://service.oxvatech.cn/anniversary/shareChance',params);
                if(res.data.status == 200){
                    this.emailStr = ''
                }else{
                    showMessage('Error','error')
                }
                 
            }else{
                showMessage('Email format error','error')
            }
        },
        QuickFind(){
            var countryList = this.$refs.countryList; // 获取 .country_option 元素
            // 找到第一个以输入字母开头的国家元素
            var targetCountry = Array.from(countryList.children).find((country) =>
                country.textContent.trim().toLowerCase().startsWith(this.findText.toLowerCase())
            );

            if (targetCountry) {
                // 滚动到目标国家
                targetCountry.scrollIntoView({ block: 'start' });
            }
        },
        // 上传前验证
        toUpload(){
            if(!this.isLogin){
                this.popup = this.loginPopup = true
            }else{
                if(this.myBlessing == ''){
                    this.popup = this.formPopup = true
                    showMessage('Please write a blessing first','success')
                }else{
                    this.$refs.fileInput.click();
                }
            }
        },
        //上传图片
        uploadFile(event){
            if(!this.uploadFlag){
                var file = event.target.files[0]
                if(file.size>5*1024*1024){
                    showMessage('The uploaded file cannot exceed 5M','error')
                    this.$refs.fileInput.value = "";
                    return;
                }else if(this.file.length==1){
                    showMessage('Upload up to 1 files','error')
                    this.$refs.fileInput.value = "";
                    return;
                }else{
                    var that = this
                    this.uploadFlag=false
                    const reader = new FileReader();
                    reader.onload = function(e) {
                        that.uploadImg = e.target.result; // 将图片的 base64 数据设为 img 的 src
                        $('.up_center').on('load', function(){
                            var width = $('.up_center').width()
                            var height = $('.up_center').height()
                            if(width>height){
                                that.imgStyle = true
                            }else{
                                that.imgStyle = false
                            }
                            this.$refs.fileInput.value = "";
                        })
                        that.downloadUploadImg()
                    };
                    reader.readAsDataURL(file); // 读取文件数据为 Data URL
                }
            }
        },
        //下载自定义图片
        async downloadUploadImg(){
            if(!this.downloadFlag){
                showMessage('Upload successful, please wait. . .','success')
                this.downloadFlag = this.imgFlag2 = true
                setTimeout(() => {
                    const element = document.getElementById('imgDiv2'); // 要保存的DOM元素
    
                    // 使用html2canvas并启用useCORS和allowTaint选项
                    html2canvas(element, { 
                        useCORS: true,      // 允许跨域图片
                        allowTaint: false   // 禁止 taint 跨域图片
                    }).then(canvas => {
                        // 将canvas转换为图片数据URL
                        const imgData = canvas.toDataURL('image/png');
                        
                        // 创建一个下载链接
                        const link = document.createElement('a');
                        link.href = imgData;
                        link.download = 'OXVA_5TH_ANNIVERSARY.png'; // 设置文件名
                        link.click(); // 触发下载
                        this.downloadFlag = this.imgFlag2 = false
                    });
                }, 100);
            }
        },
        //下载图片
        async downloadImg(){
            if(!this.isLogin){
                this.popup = this.loginPopup = true
            }else{
                if(this.myBlessing == ''){
                    this.popup = this.formPopup = true
                    showMessage('Please write a blessing first','success')
                }else{
                    if(!this.downloadFlag){
                        showMessage('Downloading, please wait. . .','success')
                        this.downloadFlag = this.imgFlag = true
                        setTimeout(() => {
                            const element = document.getElementById('imgDiv'); // 要保存的DOM元素
            
                            // 使用html2canvas并启用useCORS和allowTaint选项
                            html2canvas(element, { 
                                useCORS: true,      // 允许跨域图片
                                allowTaint: false   // 禁止 taint 跨域图片
                            }).then(canvas => {
                                // 将canvas转换为图片数据URL
                                const imgData = canvas.toDataURL('image/png');
                                
                                // 创建一个下载链接
                                const link = document.createElement('a');
                                link.href = imgData;
                                link.download = 'OXVA_5TH_ANNIVERSARY.png'; // 设置文件名
                                link.click(); // 触发下载
                                this.downloadFlag = this.imgFlag = false
                            });
                        }, 100);
                    } 
                }
            }
            
        },
        //获取个人最新祝福
        async getMyBlessing(){
            let params=new URLSearchParams();
            params.append('info',JSON.stringify({name:this.user.name}));
            let res = await axios.post('https://service.oxvatech.cn/anniversary/getMyBlessing',params);
            if(res.data.status == 200){
                if(res.data.data.length>0){
                    //获取最新的祝福
                    this.myBlessing = res.data.data[res.data.data.length-1].text
                }
            }else{
                showMessage('server error','error')
            }
        },
        //获取前一天展示祝福
        async getBlessing(){
            // 创建一个当前日期的对象
            var date = new Date();

            // 将日期转换为东八区时间
            var chinaTime = new Date(date.toLocaleString("en-US", { timeZone: "Asia/Shanghai" }));

            // 获取前一天的日期
            chinaTime.setDate(chinaTime.getDate() - 1);

            // 格式化成 YYYY-MM-DD
            var nowDay = chinaTime.toISOString().split('T')[0];

            if(new Date(nowDay) < new Date('2024-11-03')){
                nowDay = '2024-11-03'
            }else if(new Date(nowDay) > new Date('2024-12-09')){
                nowDay = '2024-12-09'
            }
            let res = await axios.get(`https://service.oxvatech.cn/anniversary/getBlessing/${nowDay}`)
            if(res.data.status == 200){
                this.blessing = res.data.data
                
                if(window.innerWidth>750){
                    var box3S = 14000
                }else{
                    box3S = 10000
                }
                setTimeout(() => {
                    new Swiper('.box3Swiper', {
                        speed:box3S,
                        loop:true,
                        autoplay: {
                          delay: 0,
                        }
                    })
                }, 1000);
                
            }else{
                showMessage('server error','error')
            }
        },
        //提交祝福
        async submitForm(){
            if(this.text1=='' || this.text2=='' || this.text3==''){
                showMessage('Please fill in the information completely','error')
            }else{
                if(!this.formFlag){
                    var textArr = [
                        `<span>OXVA = ${this.text1}!</span> My favorite part is the ${this.text2}, and I'm excited to see ${this.text3} coming soon! Cheers to many more years!`,
                        `<span>OXVA is ${this.text1}!</span> I love its ${this.text2}, and I can't wait for ${this.text3}! Cheers to the 5 years!`,
                        `<span>Celebrating 5 years</span> of the ${this.text1} OXVA! Enjoying the ${this.text2} and looking forward to ${this.text3}!`,
                        `<span>Happy 5th anniversary, OXVA!</span> Loving the ${this.text2} and excited for the ${this.text3}! OXVA is ${this.text1}! `,
                        `<span>OXVA 5th Anniversary:</span> I hope you keep ${this.text1}! Over the years, OXVA's  ${this.text2} never lets me down! Cheers to having ${this.text3} in the future!`
                    ]
                    var randomInt = Math.floor(Math.random() * 5);

                    this.myBlessing = textArr[randomInt]
                    this.formFlag = true

                    this.formPopup = false
                    if(window.innerWidth>750){
                        var bm_x='45rem',bm_y='-30rem'
                    }else{
                        bm_x='20rem',bm_y='-20rem'
                    }
                    var move = gsap.timeline({})
                    move.to('.bp_move',{opacity:1,duration:1}).to('.bp_move',{x:bm_x,y:bm_y,opacity:0,duration:1},'+=2')
                    setTimeout(() => {
                        showMessage('Submitted successfully','success')
                        this.popup = false
                    }, 4000);

                    let params=new URLSearchParams();
                    params.append('info',JSON.stringify({name:this.user.name,text:this.myBlessing}));
                    let res = await axios.post('https://service.oxvatech.cn/anniversary/addForm',params);
                    if(res.data.status == 200){
                        this.user.isForm = true
                        this.user.chance = this.user.chance+1
                    }else{
                        showMessage('server error','error')
                    }
                }
                
            }
        },
        //填写地址
        async submitAddress(){
            if(this.address.state == '' || this.address.city == '' || this.address.street == '' || this.address.postal == '' || this.address.phone == ''){
                showMessage('Please fill in the information completely','error')
            }else{
                if(!this.addressFlag){
                    this.addressFlag = true
                    this.address.name = this.user.name
                    let params=new URLSearchParams();
                    params.append('info',JSON.stringify(this.address));
                    let res = await axios.post('https://service.oxvatech.cn/anniversary/addAddress',params);
                    if(res.data.status == 200){
                        showMessage('Submitted successfully','success')
                        this.user.isAddress = true
                        this.popup = this.addressPopup = false
                    }else{
                        showMessage('server error','error')
                    }
                }
            }
        },
        //获取所有中奖者
        async getAllWin(){
            let res = await axios.get(`https://service.oxvatech.cn/anniversary/getAllWin`)
            if(res.data.status == 200){
                this.winners = res.data.data
                if(this.winners.length>0){
                    for(let i of this.winners){
                        if(i.name == this.user.name){
                            this.prizeName = i.prize
                        } 
                    }
                }
                setTimeout(() => {
                    new Swiper('.box6Swiper', {
                        direction: 'vertical',
                        slidesPerView: 10,
                        centeredSlides: true,
                        // loop:true,
                        autoplay:true
                    })
                }, 1000);
            }else{
                showMessage('server error','error')
            }
        },
        //转动转盘
        move(){
            Object.keys(this.prizeAll).forEach((key)=>{
                if(this.prizeAll[key]){
                    //指向哪个奖品停止
                    this.className = key
                }
            })
            setTimeout(()=>{
                //显示奖品
                this.popup = this.prizePopup = true
                //恢复转盘
                this.className = ''
                //可再次抽奖
                this.isLottery=true
            },6500)
        },
        //开始抽奖
        async lottery(){
            if(!this.isLogin){
                //未注册
                this.popup = this.loginFlag = true;
            }else{
                //执行完成前只能点击一次
                if(this.isLottery){
                    //是否有机会 
                    if(this.user.chance > 0){
                        //抽奖
                        this.isLottery = false
                        let params=new URLSearchParams();
                        params.append('info',JSON.stringify(this.user));
                        let res = await axios.post('https://service.oxvatech.cn/anniversary/lottery',params);
                        if(res.status == 200){
                            //重新获取信息
                            this.getInfo()
                            if(res.data.status == 1){
                                //没机会 提示
                                showMessage('No chance. Come back tomorrow.','error')
                            }else if(res.data.status == 2){
                                //未中奖
                                this.prizeAll.Lucky_Try = true
                                this.move()
                            } if(res.data.status == 3){
                                //中奖
                                this.prizeName = res.data.data
                                var str = res.data.data.replace(/ /g, '_'); //空格转为下划线
                                this.prizeAll[str] = true
                                this.move()
                            }
                        }
                    }else{
                        //没机会 提示
                        showMessage('No chance. Come back tomorrow.','error')
                    }
                }
                
            }
        },
        winRecords(){
            if(this.isLogin){
                this.popup = this.recordPopup = true
            }else{
                this.popup = this.loginPopup = true
            }
        },
        //填写问卷
        addChance(){
            if(this.isLogin){
                if(JSON.parse(this.user.isForm)){
                    showMessage('Already written, take a break','error')
                }else{
                    this.popup = this.formPopup = true
                }
            }else{
                this.popup = this.loginPopup = true
            }
        },
        playNow(){
            if(this.isLogin){
                this.lottery()
            }else{
                this.popup = this.loginPopup = true
            }
        },
        endTips(){
            showMessage('The event has ended, thank you for your participation.','success')
        },
        // 发送邮箱验证
        async sendEmail(){
            if(this.user.email == ''){
                showMessage('Please enter your email','error')
            }else{
                // 邮箱正则表达式
                var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
                if(emailReg.test(this.user.email)){
                    if(!this.sendFlag){
                        this.sendText = 'Has sent'
                        this.sendFlag = true
                        var params=new URLSearchParams();
                        params.append('info',JSON.stringify(this.user));
                        let res = await axios.post('https://service.oxvatech.cn/anniversary/sendEmail',params);
                        if(res.data.status == 200){
                            this.isSend = true
                            showMessage('Email has been sent, please check.','success')
                        }
                    }else{
                        showMessage('Sent, please try again in one minute.','success')
                        setTimeout(() => {
                            this.sendFlag = false
                            this.sendText = 'Send code'
                        }, 1000*60);
                    }
                    
                }else{
                    showMessage('Email format error','error')
                }
            }
        },
        emailUpdate(){
            if(this.isSend){
                this.isSend = false
                this.sendFlag = false
                this.sendText = 'Send code'
            }
        },
        //登录
        async loginActivity(){
            if(this.isSend){
                if(this.user.name == '' || this.user.email == '' || this.user.country == 'Country' || this.user.code == ''){
                    showMessage('Please fill in the information completely','error')
                }else{
                    // 邮箱正则表达式
                    var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
                    if(emailReg.test(this.user.email)){
                        //避免重复提交
                        if(!this.loginFlag){
                            this.loginFlag = true
                            var params=new URLSearchParams();
                            params.append('info',JSON.stringify(this.user));
                            let res = await axios.post('https://service.oxvatech.cn/anniversary/loginActivity',params);
                            if(res.data.status == 200){
                                this.isLogin = true
                                this.setCookie('_oxva_activity_',res.data.data,60)
                                showMessage('Login successful','success')
                                this.popup = this.loginPopup = false
                                setTimeout(() => {
                                    location.reload()
                                }, 500);
                            }else if(res.data.status == 201){
                                this.loginFlag = false
                                showMessage('Email verification code error','error')
                            }else if(res.data.status == 202){
                                this.loginFlag = false
                                showMessage('Username already exists','error')
                            }  
                        }
                    }else{
                        showMessage('Email format error','error')
                    }
                }
            }else{
                showMessage('Please send the email verification code first','error')
            }
        },
        //用于登录后刷新页面时获取用户信息
        async getInfo(){
            let params=new URLSearchParams();
            params.append('info',JSON.stringify({token:this.user.token}));
            let res = await axios.post('https://service.oxvatech.cn/anniversary/getInfo',params);
            if(res.data.status == 200){
                if(res.data.data.length>0){
                    this.isLogin = true
                    this.user = res.data.data[0]
                    //console.log(this.user)
                    // 获取信息
                    //this.getAllWin()
                    //this.getMyBlessing()
                }else{
                    this.isLogin = false
                }
            }else{
                showMessage('server error','error')
            }
        },
        // cookie
        setCookie(name,value,day){
            var d = new Date();
            d.setTime(d.getTime() + (day * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = name + "=" + value + ";" + expires + ";path=/";
        },
        getCookie(name){
            var name = name + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var cookieArray = decodedCookie.split(';');
            for(let i = 0; i < cookieArray.length; i++) {
                let cookie = cookieArray[i];
                while (cookie.charAt(0) == ' ') {
                cookie = cookie.substring(1);
                }
                if (cookie.indexOf(name) == 0) {
                return cookie.substring(name.length, cookie.length);
                }
            }
            return "";
        },
        async getCountry(){
            let res = await axios.get('https://service.oxvatech.cn/public/getAllCountry')
            if(res.status == 200){
                //this.countryArr = res.data.info serve
                this.countryArr = res.data.data
            }
        },
    },
    created(){
        //this.getBlessing()
        // 加载完成后 更新弹窗显示样式
        this.loadFlag = true
        //判断登录状态
        this.user.token = this.getCookie('_oxva_activity_')
        if(this.user.token != ''){
            this.isLogin = true
            //获取用户信息
            //this.getInfo()
        }else{
            //this.getAllWin()
        }

        //this.getCountry()
    },
    mounted(){
        //this.getCountry()

        if(window.innerWidth>750){
            var wFlag = true, box2V = 4.5,box3S = 14000,box4S = 'top top+=20%'
        }else{
            wFlag = false,box2V = 2,box3S = 10000,box4S = 'top center'
        }
        
        var box2Swiper = new Swiper('.box2Swiper', {
            slidesPerView: box2V,
            centeredSlides: true,
            loop:true,
            autoplay: {
                disableOnInteraction: false,
            },
            on: {
                slideChangeTransitionEnd: function(){
                    $('.box2_line div').css({opacity:0})
                    $(`.box2_line div:nth-child(${this.realIndex+1})`).css({opacity:1})
                },
            },
        })
        
        var that = this
        new Swiper('.box5Swiper', {
            effect: 'cards',
            navigation: {
                nextEl: '.box5Swiper-button-next',
                prevEl: '.box5Swiper-button-prev',
            },
            on:{
                slideChange: function(){
                    that.imgIndex = this.activeIndex
                },
            },
        })
        
        
        gsap.registerPlugin(ScrollTrigger)
        ScrollTrigger.refresh();
        
        if(wFlag){
            ScrollTrigger.create({
                trigger:'.box1',
                start:'top top+=12%',
                end:'+=0',
                // markers:true,
                onEnter: () => {
                    $('.box1_img3').css({transform:'none'})
                    $('.box1_icon1').css({transform:'none'})
                    $('.box1_icon2').css({transform:'none'})
                    $('.box1_icon3').css({transform:'none'})
                    $('.box1_icon4').css({transform:'none'})
                    $('.box1_icon5').css({transform:'none'})
                    $('.box1_icon6').css({transform:'none'})
                }
            })

            ScrollTrigger.create({
                trigger:'.box3',
                start:'top center',
                end:'+=0',
                // markers:true,
                onEnter: () => {
                    box2Swiper.disable();
                    $('.box2Swiper').css({transform:'translateY(31rem) scale(0)'})
                    $('.box2_line').css({opacity:0})
                },
                onLeaveBack: () => {
                    box2Swiper.enable();
                    $('.box2Swiper').css({transform:'translateY(0) scale(1)'})
                    $('.box2_line').css({opacity:1})
                }
            })
        
            ScrollTrigger.create({
                trigger:'.Mbox5_style',
                start:'top bottom-=20%',
                end:'+=0',
                // markers:true,
                onEnter: () => {
                    $('.Mbox5_style').addClass('showup')
                },
                onLeaveBack: () => {
                    $('.Mbox5_style').removeClass('showup')
                }
            })
        
            ScrollTrigger.create({
                trigger:'.box5_items',
                start:'top bottom-=20%',
                end:'+=0',
                // markers:true,
                onEnter: () => {
                    $('.box5_left').addClass('showup2')
                    $('.box5_right').addClass('showup2')
                },
                onLeaveBack: () => {
                    $('.box5_left').removeClass('showup2')
                    $('.box5_right').removeClass('showup2')
                }
            })
        }else{
            gsap.to('.Mbox5_style',{
                x:'-41rem',
                scrollTrigger:{
                    trigger:'.box5',
                    start:'top+=10% top+=6%',
                    end:'+=100%',
                    scrub:1,
                    // markers:true,
                    onUpdate:(self)=>{
                        var index = self.progress.toFixed(3) * 100
                        
                    }
                }
            })
            gsap.to('.box5',{
                scrollTrigger:{
                    trigger:'.box5',
                    start:'top top+=6%',
                    pin:true,
                    end:'+=150%',
                    // markers:true,
                    onUpdate:(self)=>{
                        var index = self.progress.toFixed(3) * 100
                        
                    }
                }
            })
        }
        
        ScrollTrigger.create({
            trigger:'.box4_lottery',
            start:box4S,
            end:'+=0',
            // markers:true,
            onEnter: () => {
                $('.box4_bless').css({transform:'translate(0, 0)'})
                setTimeout(() => {
                    $('.box4_icon3').css({opacity:1})
                }, 500);
            },
            onLeaveBack: () => {
                // $('.box4_bless').css({transform:'translate(-15rem, -5rem)'})
                // $('.box4_icon3').css({opacity:0})
            }
        })
        
        ScrollTrigger.create({
            trigger:'.box2_title',
            start:'top bottom-=20%',
            end:'+=0',
            toggleActions:'play none none reverse',
            // markers:true,
            onEnter: () => {
                $('.box2_title').addClass('showup')
            },
            onLeaveBack: () => {
                $('.box2_title').removeClass('showup')
            }
        })
        
        ScrollTrigger.create({
            trigger:'.box4l_img',
            start:'top bottom-=30%',
            end:'+=0',
            // markers:true,
            onEnter: () => {
                $('.box4l_img').addClass('box4l_before')
                that.isLottery = false;
                setTimeout(() => {
                    that.isLottery = true;
                }, 3000);
            },
            onLeaveBack: () => {
                // $('.box4l_img').removeClass('box4l_before')
            }
        })
        
        ScrollTrigger.create({
            trigger:'.box5_title',
            start:'top bottom-=20%',
            end:'+=0',
            // markers:true,
            onEnter: () => {
                $('.box5_title').addClass('showup')
            },
            onLeaveBack: () => {
                $('.box5_title').removeClass('showup')
            }
        })
        
        ScrollTrigger.create({
            trigger:'.box6_title',
            start:'top bottom-=20%',
            end:'+=0',
            toggleActions:'play none none reverse',
            // markers:true,
            onEnter: () => {
                $('.box6_title').addClass('showup')
            },
            onLeaveBack: () => {
                $('.box6_title').removeClass('showup')
            }
        })
    }
})

